@if (mySharesPortfolio) {
  <div class="row pt-3">
    <div class="col-lg-3 total-data total-value">
      <div class="font-weight-bold">{{ 'mysec.portfolioValue' | translate }}</div>
      <div class="value">{{ mySharesPortfolio.value | numberSuffix }}</div>
    </div>
    <div class="col-lg-3 total-data total-gains">
      <div class="font-weight-bold">{{ 'mysec.realizedGains' | translate }}</div>
      <div class="value">{{ mySharesPortfolio.gains | numberSuffix }}</div>
    </div>
  </div>
}
@if (!isLoading && shares) {
  <div class="row mt-4">
    <div class="col-12">
      <div class="mattable-container mysec-table">
        <mat-table class="responsive-table" [dataSource]="shares">
          <ng-container matColumnDef="Company">
            <mat-header-cell *matHeaderCellDef>{{ 'company.company' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <div class="cursor-pointer" (click)="viewDetails(item)">
                <div class="text-black font-weight-bold">{{ item.companyName }}</div>
                <div class="font-size-small">{{ item.registrationNo }}</div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="TickerCode">
            <mat-header-cell *matHeaderCellDef
              >{{ 'mysec.tickerCode' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.tickerCode }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="ShareQty">
            <mat-header-cell *matHeaderCellDef>{{ 'mysec.shareQty' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.shareQty | number }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="PurchasedPrice">
            <mat-header-cell *matHeaderCellDef
              >{{ 'mysec.purchasedPrice' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.purchasedPrice | numberSuffix: { numberFormat: '1.2-2' } }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="MarketPrice">
            <mat-header-cell *matHeaderCellDef
              >{{ 'mysec.marketPrice' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.marketPrice | numberSuffix: { numberFormat: '1.2-2' } }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Profit">
            <mat-header-cell *matHeaderCellDef
              >{{ 'mysec.unrealizedProfitLoss' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span [class.text-primary]="item.profit < 0" [class.text-profit]="item.profit >= 0">
                {{
                  (item.profit < 0 ? -1 * item.profit : item.profit)
                    | numberSuffix: { numberFormat: '1.2-2' }
                }}</span
              >
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Action">
            <mat-header-cell *matHeaderCellDef>{{ 'common.action' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <div class="action" ngbDropdown container="body" placement="auto">
                <div
                  class="pitchin-icon pitchin-icon-more-horizontal no-caret"
                  ngbDropdownToggle
                ></div>
                <div ngbDropdownMenu>
                  <div
                    class="font-weight-bold cursor-pointer"
                    ngbDropdownItem
                    [routerLink]="['/pstx', item.tickerCode]"
                  >
                    {{ 'mysec.tradeOrOffer' | translate }}
                  </div>
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayColumns"> </mat-header-row>
          <mat-row *matRowDef="let item; columns: displayColumns"> </mat-row>
        </mat-table>
      </div>
    </div>
    @if (!shares || shares.length == 0) {
      <div class="col-12 py-4 text-center">
        {{ 'common.noRecord' | translate }}
      </div>
    }
  </div>
}
@if (isLoading) {
  <agmo-loading></agmo-loading>
}
@if (total > params.take) {
  <div class="row">
    <div class="col-lg-12">
      <div class="paging mt-3">
        <ngb-pagination
          [collectionSize]="total"
          [(pageSize)]="params.take"
          [(page)]="params.currentPage"
          (pageChange)="getMyShares()"
          [maxSize]="5"
          [rotate]="true"
        >
          <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
          <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
          <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
}
